import { ClientApiService } from './service/ClientApiService';

export const clientApiService: ClientApiService = new ClientApiService();
